import { getResolvedRef as e } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { resolve as t } from "@scalar/workspace-store/resolve";
import { isArraySchema as n } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
import { isObjectEqual as r } from "@scalar/helpers/object/is-object-equal";
import { objectKeys as i } from "@scalar/helpers/object/object-keys";
//#region src/schema/helpers/merge-all-of-schemas.ts
var a = /* @__PURE__ */ new Set(["description", "title"]), o = [
	"x-enum-varnames",
	"x-enumNames",
	"x-enum-descriptions",
	"x-enumDescriptions"
], s = (e, t, n = !1) => {
	let i = e.enum === void 0 ? t.enum?.slice() : t.enum === void 0 ? e.enum.slice() : e.enum.filter((e) => t.enum?.some((t) => r(e, t)));
	if (i === void 0) return {};
	let a = { enum: i };
	for (let s of o) {
		let o = t[s] !== void 0 && (n || e[s] === void 0) ? t : e, c = o[s], l = o.enum;
		Array.isArray(c) ? a[s] = l === void 0 ? c : i.map((e) => c[l.findIndex((t) => r(e, t))] ?? "") : c !== void 0 && (s === "x-enum-descriptions" || s === "x-enumDescriptions") && (a[s] = c);
	}
	return a;
}, c = (e, n, r = /* @__PURE__ */ new Set()) => {
	if (!e?.allOf?.length || !Array.isArray(e.allOf)) return n || {};
	let i = {}, { allOf: a, ...o } = e;
	for (let n of e.allOf) {
		if (!n || typeof n != "object") continue;
		let e = t.schema(n);
		if (e.allOf) {
			l(i, c(e, void 0, r), !1, r);
			continue;
		}
		l(i, e, !1, r);
	}
	Object.keys(o).length > 0 && l(i, o, !0, r), n && typeof n == "object" && (n.allOf ? l(i, c(n, void 0, r), !0, r) : l(i, n, !0, r));
	let s = "discriminator" in o || !!(n && typeof n == "object" && "discriminator" in n);
	return "discriminator" in i && !s && delete i.discriminator, i;
}, l = (r, o, l = !1, f = /* @__PURE__ */ new Set()) => {
	let p = i(o);
	if (p.length === 0) return;
	let m = s(r, o, l);
	for (let i of p) {
		let s = i, p = e(o[i]);
		if (p !== void 0) if (s === "required") Array.isArray(p) && p.length > 0 && (r.required?.length ? r.required = [.../* @__PURE__ */ new Set([...r.required, ...p])] : r.required = p.slice());
		else if (s === "properties") p && typeof p == "object" && (r.properties ||= {}, u(r.properties, p, f));
		else if (s === "items") {
			let i = t.schema(p);
			if (i) if (n(o)) if (r.items ||= {}, i.allOf) {
				let e = c(i, void 0, f);
				Object.assign(r.items, e);
			} else d(e(r.items), i, f);
			else if (i.allOf) {
				let e = c(i, void 0, f);
				"properties" in e && ("properties" in r || (r.properties = {}), "properties" in r && u(r.properties, e.properties, f));
			} else "items" in r || (r.items = i);
		} else if (i === "enum") continue;
		else if (i === "oneOf" || i === "anyOf") Array.isArray(p) && p.length > 0 && (l || r[i] === void 0) && (r[i] = p);
		else if (i === "allOf") continue;
		else (l || a.has(s) || r[i] === void 0) && (r[i] = p);
	}
	Object.assign(r, m);
}, u = (e, r, i = /* @__PURE__ */ new Set()) => {
	let a = Object.keys(r ?? {});
	if (!(!r || !e || a.length === 0)) for (let o of a) {
		let a = t.schema(r[o]);
		if (!a) {
			delete e[o];
			continue;
		}
		if (typeof a != "object") {
			e[o] = a;
			continue;
		}
		if (!e[o]) {
			let s = r[o], l = s?.$ref;
			if (s && typeof l == "string" && i.has(l)) {
				e[o] = s;
				continue;
			}
			let u = typeof l == "string" ? new Set(i).add(l) : i;
			a.allOf ? e[o] = c(a, void 0, u) : n(a) && t.schema(a.items)?.allOf ? e[o] = {
				...a,
				items: c(t.schema(a.items), void 0, i)
			} : r[o] && (e[o] = r[o]);
			continue;
		}
		let l = t.schema(e[o]), d = a.$ref;
		if (typeof d == "string" && i.has(d)) {
			e[o] = l;
			continue;
		}
		let p = typeof d == "string" ? new Set(i).add(d) : i;
		if (a.allOf) e[o] = c({ allOf: [l, a] }, void 0, p);
		else if (n(a) && n(l) && a.items) {
			let n = t.schema(l.items);
			e[o] = {
				...l,
				type: "array",
				items: n ? f(n, t.schema(a.items), p) : t.schema(a.items)
			};
		} else if ("properties" in l && "properties" in a) {
			let t = {
				...l,
				...a
			};
			t.properties = { ...l.properties }, u(t.properties, a.properties, p), e[o] = t;
		} else e[o] = {
			...a,
			...l,
			...s(l, a)
		};
	}
}, d = (e, n, r = /* @__PURE__ */ new Set()) => {
	if (n.allOf || e.allOf) {
		let i = [];
		if (e.allOf) for (let n of e.allOf) i.push(t.schema(n));
		else i.push(e);
		if (n.allOf) for (let e of n.allOf) i.push(t.schema(e));
		else i.push(n);
		let a = c({ allOf: i }, void 0, r);
		Object.assign(e, a);
		return;
	}
	Object.assign(e, n), "properties" in e && "properties" in n && u(e.properties, n.properties, r);
}, f = (e, t, n = /* @__PURE__ */ new Set()) => {
	let r = t.$ref;
	return typeof r == "string" ? n.has(r) ? e : p(e, t, new Set(n).add(r)) : p(e, t, n);
}, p = (e, n, r = /* @__PURE__ */ new Set()) => {
	if (e.allOf || n.allOf) {
		let i = [];
		if (e.allOf) for (let n of e.allOf) i.push(t.schema(n));
		else i.push(e);
		if (n.allOf) for (let e of n.allOf) i.push(t.schema(e));
		else i.push(n);
		return c({ allOf: i }, void 0, r);
	}
	if ("properties" in e && "properties" in n) {
		let t = {
			...e,
			...n,
			properties: { ...e.properties }
		};
		return u(t.properties, n.properties, r), t;
	}
	return {
		...e,
		...n
	};
};
//#endregion
export { c as mergeAllOfSchemas };

//# sourceMappingURL=merge-all-of-schemas.js.map